var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
// All runtime config is injected via window.__ENV from /env-config.js,
// which is generated by entrypoint.sh at container startup based on
// PROJECT and ENV environment variables passed to the container.
export const Constants = {
    REACT_APP_BASE_URL_ZA: (_a = window.__ENV) === null || _a === void 0 ? void 0 : _a.REACT_APP_BASE_URL_ZA,
    REACT_APP_BASE_URL_US: (_b = window.__ENV) === null || _b === void 0 ? void 0 : _b.REACT_APP_BASE_URL_US,
    REACT_APP_BASE_URL_IN: (_c = window.__ENV) === null || _c === void 0 ? void 0 : _c.REACT_APP_BASE_URL_IN,
    REACT_APP_CLIENT_ID: (_d = window.__ENV) === null || _d === void 0 ? void 0 : _d.REACT_APP_CLIENT_ID,
    REACT_APP_USER_POOL_ID: (_e = window.__ENV) === null || _e === void 0 ? void 0 : _e.REACT_APP_USER_POOL_ID,
    REACT_APP_USER_POOL: (_f = window.__ENV) === null || _f === void 0 ? void 0 : _f.REACT_APP_USER_POOL,
    REACT_APP_GOOGLE_CLIENT_ID: (_g = window.__ENV) === null || _g === void 0 ? void 0 : _g.REACT_APP_GOOGLE_CLIENT_ID,
    REACT_APP_GOOGLE_PASSWORD: (_h = window.__ENV) === null || _h === void 0 ? void 0 : _h.REACT_APP_GOOGLE_PASSWORD,
    REACT_APP_API_BASE_URL: (_j = window.__ENV) === null || _j === void 0 ? void 0 : _j.REACT_APP_API_BASE_URL,
    REACT_APP_API_BASE_URL_B2B: process.env.REACT_APP_BASE_URL_B2B,
    REACT_APP_API_BASE_URL_ONBOARDING: (_k = window.__ENV) === null || _k === void 0 ? void 0 : _k.REACT_APP_API_BASE_URL_ONBOARDING,
    REACT_APP_API_BASE_URL_STORE: (_l = window.__ENV) === null || _l === void 0 ? void 0 : _l.REACT_APP_API_BASE_URL_STORE,
    REACT_APP_API_STORE_URL: (_m = window.__ENV) === null || _m === void 0 ? void 0 : _m.REACT_APP_API_STORE_URL,
    REACT_APP_MAP_APP_ID: (_o = window.__ENV) === null || _o === void 0 ? void 0 : _o.REACT_APP_MAP_APP_ID,
    REACT_APP_MAP_APP_CODE: (_p = window.__ENV) === null || _p === void 0 ? void 0 : _p.REACT_APP_MAP_APP_CODE,
    REACT_APP_MAP_KEY: (_q = window.__ENV) === null || _q === void 0 ? void 0 : _q.REACT_APP_MAP_KEY,
    REACT_APP_CAPTCHA_KEY: (_r = window.__ENV) === null || _r === void 0 ? void 0 : _r.REACT_APP_CAPTCHA_KEY,
    STRIPE_PUBLIC_KEY: (_s = window.__ENV) === null || _s === void 0 ? void 0 : _s.STRIPE_PUBLIC_KEY,
    CLARITY_PROJECT_ID: (_t = window.__ENV) === null || _t === void 0 ? void 0 : _t.CLARITY_PROJECT_ID,
    GOOGLE_API_KEY: (_u = window.__ENV) === null || _u === void 0 ? void 0 : _u.GOOGLE_API_KEY,
};
export const REMITTANCE_SYSTEM_USER_NAME = "Remittance System User";
export const REMITTANCE_SYSTEM_USER_ID = "11111111-1111-1111-1111-111111111111";
export const CARRIER_CODE = {
    DHL: "DHL",
    BLUE_DART: "BLUEDART",
    SHIPPIT: "SHIPPIT",
    USPS: "USPS",
    UPS: "UPS",
    FEDEX: "FEDEX",
    LSO: "LSO",
    "Canada Post": "Canada Post",
    UPSDAP: "UPSDAP",
    FedExDefault: "FedExDefault",
    Xpressbess: "Xpressbees",
    Delhivery: "Delhivery",
    Ecom: "Ecom",
    DTDC: "DTDC",
    DTDC_B2B: "DTDC-B2B",
    BLITZ: "Blitz",
    ZIPPYYSHADOWFAX: "ZippyyShadowfax",
    ZIPPYYXEKART: "ZippyyxEkart",
    ZIPPYYXDELHIVERY: "ZippyyxDelhivery",
    ZIPPYYXSHREEMARUTI: "ZippyyxShreeMaruti",
    ZIPPYYEBLUEDART: "ZippyyeBlueDart",
    ZIPPYYEEKART: "ZippyyeEkart",
    ZIPDASH: "ZipDash",
    SHIPNEXADELHIVERY: "ShipnexaDelhivery",
    ZYPDASH: "ZypDash",
    ATSHEAVY: "ATSHEAVY",
    ATSBAU: "ATSBAU",
    ATS: "ATS",
};
export const ORDER_STATUS = {
    NEW: "NEW",
    PAYMENT_PENDING: "PAYMENT_PENDING",
    AWAITING_PICKUP: "AWAITING_PICKUP",
    PRE_TRANSIT: "PRE_TRANSIT",
    IN_TRANSIT: "IN_TRANSIT",
    OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
    DELIVERED: "DELIVERED",
    AVAILABLE_FOR_PICKUP: "AVAILABLE_FOR_PICKUP",
    RETURN_TO_SENDER: "RETURN_TO_SENDER",
    FAILURE: "FAILURE",
    CANCELED: "CANCELED",
    ERROR: "ERROR",
};
export const SHIPMENT_PURCHASE_FEES_OPTIONS = {
    BOTH_SHIPMENT_AND_PICKUP: "BothShipmentAndPickup",
    ONLY_SHIPMENT: "OnlyShipment",
    ONLY_PICKUP: "OnlyPickup",
};
export const SOURCE_TYPE = {
    SHOPIFY: "Shopify",
    ZIPPYY: "Zippyy",
};
export const manualOrderHeaderItems = [
    "Sender Address",
    " Receiver Address",
    "Parcel Information",
    "Product details",
    "Carrier & Service",
    "Payment",
];
export const createdOrderHeaderItems = ["Payment"];
export const batchShipmentHeaderItems = ["Carrier and service", "Payment"];
export const PICKUP_DROP_LOCATION = [
    "In/At mailbox",
    "On the porch",
    "Front door",
    "Back door",
    "Side door",
    "Knock on door/Ring bell",
    "Mail room",
    "Office",
    "Reception",
    "Other ( additional instruction required )",
];
export const FILTER_ORDER_BY_OPTIONS = [
    {
        name: "Order number",
        value: "ORDER_NUMBER",
    },
    {
        name: "Order id",
        value: "ORDER_ID",
    },
    {
        name: "AWB",
        value: "TRACKING_CODE",
    },
    {
        name: "Receiver number",
        value: "RECEIVER_PHONE_NUMBER",
    },
    {
        name: "Receiver email",
        value: "RECEIVER_EMAIL_ADDRESS",
    },
];
export const FILTER_PAYMENT_LOGS_OPTIONS = [
    {
        name: "Order number",
        value: "ORDER_NUMBER",
    },
    {
        name: "Order id",
        value: "ORDER_ID",
    },
];
export const FILTER_SHIPMENT_CHARGES_OPTIONS = [
    {
        name: "Order number",
        value: "ORDER_NUMBER",
    },
    {
        name: "Order id",
        value: "ORDER_ID",
    },
    {
        name: "AWB",
        value: "TRACKING_CODE",
    },
];
export const INSTRUCTIONS = "instructions";
export const ERROR = "error";
export const DRY_ICE_TYPES = {
    MEDICAL: "Medical",
    NON_MEDICAL: "Non-Medical",
};
export const BULK_ACTION_OPTIONS = [{ name: "Ship selected", value: "shipSelected" }];
export const BULK_ACTION_OPTIONS_PRE_TRANSIT = [{ name: "Download labels", value: "downloadLabels" }];
export const BULK_ACTION_OPTIONS_RTO = [{ name: "Mark RTO received", value: "markRtoReceived" }];
export const BULK_ACTION_OPTIONS_IN_TRANSIT = [{ name: "Download invoice", value: "downloadInvoice" }];
export const BULK_ACTION_OPTIONS_OUT_OF_DELIVERY = [{ name: "Download invoice", value: "downloadInvoice" }];
export const BULK_ACTION_OPTIONS_DELIVERED = [{ name: "Download invoice", value: "downloadInvoice" }];
export const BULK_ACTION_OPTIONS_UNDELIVERED = [
    { name: "Request reattempt", value: "requestReattempt" },
    { name: "Request for RTO", value: "requestForRTO" },
];
export const CONFIGURATION_TABS = ["box"];
export const COMMUNICATION_TABS = ["whatsapp", "email"];
export const BULK_ACTION_DOWNLOAD_TYPE = [{ name: "Labels", value: "Labels" }];
export const FILTERS_ORDER_STATUS = [
    {
        name: "New",
        value: "new",
    },
    {
        name: "Pre-transit",
        value: "pre_transit",
    },
    {
        name: "In-transit",
        value: "in_transit",
    },
    {
        name: "Delivered",
        value: "delivered",
    },
    {
        name: "Out for delivery",
        value: "out_for_delivery",
    },
    {
        name: "RTO",
        value: "RTO",
    },
    {
        name: "Undelivered",
        value: "undelivered",
    },
    {
        name: "Cancelled",
        value: "cancelled",
    },
];
export const FILTERS_RTO_RECEIVED = [
    {
        name: "True",
        value: "true",
    },
    {
        name: "False",
        value: "false",
    },
];
export const SORT_BY_OPTIONS = {
    CREATED_AT: "createdAt",
    UPDATED_AT: "updatedAt",
    ORDER_SOURCE: "orderSource",
    ORDER_TYPE: "orderType",
    ORDER_NUMBER_H_TO_L: "orderNumberHighToLow",
    ORDER_NUMBER_L_TO_H: "orderNumberLowToHigh",
    ORDER_AMOUNT_H_TO_L: "orderAmountHighToLow",
    ORDER_AMOUNT_L_TO_H: "orderAmountLowToHigh",
    PICKUP_LOCATION: "pickupLocation",
    RECEIVER_STATE: "receiverState",
    CARRIER: "carrier",
    PICKUP_DATE: "pickupDate",
    EST_DELIVERY_DATE: "estDeliveryDate",
    DELIVERED_DATE: "deliveryDate",
};
export const FILTER_REMITTANCE_BY_OPTIONS = [
    {
        name: "Order number",
        value: "ORDER_NUMBER",
    },
    {
        name: "Order id",
        value: "ORDER_ID",
    },
    {
        name: "AWB",
        value: "TRACKING_CODE",
    },
    {
        name: "Remittence id",
        value: "REMITTENCE_ID",
    },
    {
        name: "Bank transaction id",
        value: "BANK_TRANSACTION_ID",
    },
];
export const FILTERS_REMITTANCE_STATUS = [
    {
        name: "Upcoming",
        value: "upcoming",
    },
    {
        name: "Transferred",
        value: "transferred",
    },
    {
        name: "Delayed",
        value: "delayed",
    },
    {
        name: "Failed",
        value: "failed",
    },
];
export const PAYMENT_LOGS_SORT_OPTIONS = {
    CREATED_AT: "createdAt",
    UPDATED_AT: "updatedAt",
    ORDER_NUMBER_H_TO_L: "orderNumberHighToLow",
    ORDER_NUMBER_L_TO_H: "orderNumberLowToHigh",
    ORDER_AMOUNT_H_TO_L: "orderAmountHighToLow",
    ORDER_AMOUNT_L_TO_H: "orderAmountLowToHigh",
    DESCRIPTION_A_TO_Z: "Description-AtoZ",
    DESCRIPTION_Z_TO_A: "Description-ZtoA",
};
export const hsCodeCategory = [
    "Accessory (non-battery operated)",
    "Accessory (battery-operated)",
    "Audio-Visual",
    "Bags & Travel Gear",
    "Books & Memorabilia",
    "Cameras",
    "Computers & Notebooks",
    "Documents",
    "Dry Goods & Supplements",
    "Fashion Items",
    "Gaming Equipment",
    "Health & Beauty Products",
    "Home Appliances",
    "Home Decor",
    "Jewelry",
    "Mobile Devices",
    "Pet Accessories",
    "Sports & Leisure Items",
    "Tablets",
    "Toys",
    "Watches",
];
export const SHIPMENT_CHARGES_DATE_TYPES = [
    {
        name: "Updated at",
        value: "updated_at",
    },
    {
        name: "Manifested at",
        value: "manifested_at",
    },
    {
        name: "Delivered at",
        value: "delivered_at",
    },
];
export const COD_REMITTANCE_DATE_TYPES = [
    {
        name: "Delivered date",
        value: "delivered_date",
    },
    {
        name: "Billing cycle",
        value: "billing_cycle",
    },
];
export const REPORT_TYPES = {
    SHIPMENT_CHARGES_REPORT: "Shipment charges report",
    COD_REMITTANCE_REPORT: "Remittance report",
    ALL_TRANSACTION_REPORT: "All transaction report",
};
export const DOWNLOAD_RATE_SHEET_FILES = [
    {
        name: "dtdc",
        filePath: "sampleFiles/sample_rate_dtdc.xlsx",
    },
    {
        name: "delhivery",
        filePath: "sampleFiles/sample_rate_delhivery.xlsx",
    },
    {
        name: "bluedart",
        filePath: "sampleFiles/sample_rate_bluedart.xlsx",
    },
    {
        name: "xpressbees",
        filePath: "sampleFiles/sample_rate_xpressbees.xlsx",
    },
    {
        name: "ecom",
        filePath: "sampleFiles/sample_rate_ecom.xlsx",
    },
    {
        name: "zippyybluedart",
        filePath: "sampleFiles/sample_rate_zippyybluedart.xlsx",
    },
    {
        name: "ats",
        filePath: "sampleFiles/sample_rate_ats.xlsx",
    },
    {
        name: "atsbau",
        filePath: "sampleFiles/sample_rate_atsbau.xlsx",
    },
    {
        name: "atsheavy",
        filePath: "sampleFiles/sample_rate_atsheavy.xlsx",
    },
    {
        name: "ats250gms",
        filePath: "sampleFiles/sample_rate_ats250gms.xlsx",
    },
    {
        name: "ekart",
        filePath: "sampleFiles/sample_rate_ekart.xlsx",
    },
    {
        name: "ekartpremium",
        filePath: "sampleFiles/sample_rate_ekartpremium.xlsx",
    },
    {
        name: "blitz",
        filePath: "sampleFiles/sample_rate_blitz.xlsx",
    },
    {
        name: "shadowfax",
        filePath: "sampleFiles/sample_rate_shadowfax.xlsx",
    },
    {
        name: "zippyyshadowfax",
        filePath: "sampleFiles/sample_rate_zippyyshadowfax.xlsx",
    },
    {
        name: "zippyyxekart",
        filePath: "sampleFiles/sample_rate_zippyyxekart.xlsx",
    },
    {
        name: "zippyyxdelhivery",
        filePath: "sampleFiles/sample_rate_zippyyxdelhivery.xlsx",
    },
    {
        name: "zippyyxshreemaruti",
        filePath: "sampleFiles/sample_rate_zippyyxshreemaruti.xlsx",
    },
    {
        name: "zippyyebluedart",
        filePath: "sampleFiles/sample_rate_zippyyebluedart.xlsx",
    },
    {
        name: "zippyyeekart",
        filePath: "sampleFiles/sample_rate_zippyyeekart.xlsx",
    },
    {
        name: "zipdash",
        filePath: "sampleFiles/sample_rate_zipdash.xlsx",
    },
    {
        name: "shipnexadelhivery",
        filePath: "sampleFiles/sample_rate_shipnexadelhivery.xlsx",
    },
    {
        name: "zypdash",
        filePath: "sampleFiles/sample_rate_zypdash.xlsx",
    },
];
export const BULK_ACTION_OPTIONS_WEIGHT_DISPUTE = [
    { name: "Reject all dispute", value: "reject_all_disputes" },
    { name: "Accept all dispute", value: "accept_all_disputes" },
];
export const DOWNLOAD_ZONE_MAPPING_FILES = [
    {
        name: "dtdc",
        filePath: "sampleFiles/sample_zone_dtdc.xlsx",
    },
    {
        name: "delhivery",
        filePath: "sampleFiles/sample_zone_delhivery.xlsx",
    },
    {
        name: "bluedart",
        filePath: "sampleFiles/sample_zone_bluedart.xlsx",
    },
    {
        name: "xpressbees",
        filePath: "sampleFiles/sample_zone_xpressbees.xlsx",
    },
    {
        name: "ecom",
        filePath: "sampleFiles/sample_zone_ecom.xlsx",
    },
    {
        name: "zippyybluedart",
        filePath: "sampleFiles/sample_zone_zippyybluedart.xlsx",
    },
    {
        name: "ats",
        filePath: "sampleFiles/sample_zone_ats.xlsx",
    },
    {
        name: "atsbau",
        filePath: "sampleFiles/sample_zone_atsbau.xlsx",
    },
    {
        name: "atsheavy",
        filePath: "sampleFiles/sample_zone_atsheavy.xlsx",
    },
    {
        name: "ats250gms",
        filePath: "sampleFiles/sample_zone_ats250gms.xlsx",
    },
    {
        name: "ekart",
        filePath: "sampleFiles/sample_zone_ekart.xlsx",
    },
    {
        name: "ekartpremium",
        filePath: "sampleFiles/sample_zone_ekartpremium.xlsx",
    },
    {
        name: "blitz",
        filePath: "sampleFiles/sample_zone_blitz.xlsx",
    },
    {
        name: "shadowfax",
        filePath: "sampleFiles/sample_zone_shadowfax.xlsx",
    },
    {
        name: "zippyyshadowfax",
        filePath: "sampleFiles/sample_zone_zippyyshadowfax.xlsx",
    },
    {
        name: "zippyyxekart",
        filePath: "sampleFiles/sample_zone_zippyyxekart.xlsx",
    },
    {
        name: "zippyyxdelhivery",
        filePath: "sampleFiles/sample_zone_zippyyxdelhivery.xlsx",
    },
    {
        name: "zippyyxshreemaruti",
        filePath: "sampleFiles/sample_zone_zippyyxshreemaruti.xlsx",
    },
    {
        name: "zippyyebluedart",
        filePath: "sampleFiles/sample_zone_zippyyebluedart.xlsx",
    },
    {
        name: "zippyyeekart",
        filePath: "sampleFiles/sample_zone_zippyyeekart.xlsx",
    },
    {
        name: "zipdash",
        filePath: "sampleFiles/sample_zone_zipdash.xlsx",
    },
    {
        name: "shipnexadelhivery",
        filePath: "sampleFiles/sample_zone_shipnexadelhivery.xlsx",
    },
    {
        name: "zypdash",
        filePath: "sampleFiles/sample_zone_zypdash.xlsx",
    },
];
export const FILTER_ORDER_BY_OPTIONS_WEIGHT = [
    {
        name: "Order number",
        value: "ORDER_NUMBER",
    },
    {
        name: "Order id",
        value: "ORDER_ID",
    },
    {
        name: "AWB",
        value: "TRACKING_CODE",
    },
];
export const CARRIER_LIST = [
    {
        name: "Bluedart",
        value: "bluedart",
    },
    {
        name: "DTDC",
        value: "dtdc",
    },
    {
        name: "Delhivery",
        value: "delhivery",
    },
    {
        name: "Xpressbees",
        value: "xpressbees",
    },
    {
        name: "Ecom",
        value: "ecom",
    },
    {
        name: "Zippyy Bluedart",
        value: "zippyybluedart",
    },
    {
        name: "ATS",
        value: "ats",
    },
    {
        name: "ATSBAU",
        value: "atsbau",
    },
    {
        name: "ATS250GMS",
        value: "ats250gms",
    },
    {
        name: "ATSHEAVY",
        value: "atsheavy",
    },
    {
        name: "EKart",
        value: "ekart",
    },
    {
        name: "Ekart Premium",
        value: "ekartpremium",
    },
    {
        name: "Blitz",
        value: "blitz",
    },
    {
        name: "Shadowfax",
        value: "shadowfax",
    },
    {
        name: "Zippyy Shadowfax",
        value: "zippyyshadowfax",
    },
    {
        name: "ZippyyxEkart",
        value: "zippyyxekart",
    },
    {
        name: "ZippyyxDelhivery",
        value: "zippyyxdelhivery",
    },
    {
        name: "ZippyyxShreeMaruti",
        value: "zippyyxshreemaruti",
    },
    {
        name: "ZippyyeBlueDart",
        value: "zippyyebluedart",
    },
    {
        name: "ZippyyeEkart",
        value: "zippyyeekart",
    },
    {
        name: "ZipDash",
        value: "zipdash",
    },
    {
        name: "ShipnexaDelhivery",
        value: "shipnexadelhivery",
    },
    {
        name: "ZypDash",
        value: "zypdash",
    },
];
export const DEDUCTION_TYPES = [
    {
        key: "CodCharge",
        value: "Cod charge",
    },
    {
        key: "WeightCharge",
        value: "Weight charge",
    },
    {
        key: "WhatsappCharge",
        value: "Whatsapp charge",
    },
    {
        key: "RiskScoreCharge",
        value: "Zippyy Credit Limit Reduction",
    },
    {
        key: "RtoCharge",
        value: "RTO charge",
    },
];
export const CLOSED_WEIGHT_OPTION_TYPE = [
    { name: "Rejected by carrier", value: "rejected_by_carrier" },
    { name: "Accepted by seller", value: "accepted_by_seller" },
    { name: "Accepted by carrier", value: "accepted_by_carrier" },
    { name: "Auto accepted by seller", value: "auto_accepted_by_seller" },
];
export const VASactivationServicesPayload = {
    AI_RTO_SCORE: "risk-calculation",
    ORDER_WHATSAPP: "order/address-validation",
    IVR_ORDER: "ivr/order",
    NDR_WHATSAPP_VERIFICATION: "ndr/address-validation",
    IVR_NDR: "ivr/ndr",
    OTP_VERIFIED_DELIVERY: "otp-verified-delivery",
};
